import { IDateTimeWithZone } from '../common/date-time-with-zone.interface';
import { IEntityDocumentSummary } from './entity-document-summary';
import { EntityDocumentSummary } from './entity-document-summary.class';
import { IObservationDocumentSummary } from './observation-document-summary.interface';

export class ObservationDocumentSummary extends EntityDocumentSummary implements IObservationDocumentSummary {
  constructor(iObservationDocumentSummary?: IObservationDocumentSummary) {
    super(iObservationDocumentSummary as IEntityDocumentSummary);
    this.observationId = iObservationDocumentSummary?.observationId || '00000000-0000-0000-0000-000000000000';
    this.summaryInfo = iObservationDocumentSummary?.summaryInfo || '';
    this.notesAsHtml = iObservationDocumentSummary?.notesAsHtml || '';
    this.observedBy = iObservationDocumentSummary?.observedBy || '';
  }
  observationId: string;
  summaryInfo: string;
  notesAsHtml: string;
  observedBy: string;
  observedOn: IDateTimeWithZone;
  followUpOn: IDateTimeWithZone;
}
